import React from "react";
import { loadFileInfo } from "src/common/apiFiles";
import { onError } from "src/common/onError";
import { Spin } from "antd";
import { ZAttrViewInfo } from "src/common/attrView";
import { seedSeparators } from "src/common/attrView/viewFormItems/Separator";
import { classNames } from "src/common/classNames";
import { SimpleText } from "../SimpleText/SimpleText";
import styles from "./FileList.module.less";

type PropsFileList = {
  values?: string[];
  viewInfo?: ZAttrViewInfo;
};

export const FileList: React.FC<PropsFileList> = ({ values, viewInfo }) => {
  const [labelList, setLabelList] = React.useState<React.ReactNode[]>([]);
  const [loading, setLoading] = React.useState(false);
  const init = async () => {
    try {
      if (!values || !viewInfo) return;
      setLoading(true);
      const result = await Promise.all(
        values.map(async (uid) => {
          const fileResp = await loadFileInfo(uid);
          return { fileResp, uid };
        }),
      );
      const labelDefResult = result.map(({ fileResp, uid }) => ({
        content: fileResp.fileName,
        key: uid,
      }));
      setLabelList(
        seedSeparators(labelDefResult, viewInfo.appearance?.view?.separator),
      );
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    init();
  }, []);

  return loading ? (
    <Spin spinning={loading}>...</Spin>
  ) : (
    <SimpleText
      className={classNames([
        [!!(values && values.length > 1), styles.multiple],
      ])}
      values={labelList}
      viewInfo={viewInfo}
    />
  );
};
